<div class="icon">
  <ng-content select="rt-icon"></ng-content>
</div>

<div class="spinner" *ngIf="loading">
  <rt-spinner [spinnerColor]="spinnerColor" variant="small"></rt-spinner>
</div>

<div [attr.layout-full-width]="hasFullWidthContent ? '' : null" class="text-content">
  <ng-content></ng-content>
</div>

<ng-content select="last"></ng-content>

<!-- TODO: to be removed? -->
<div class="icon-dropdown" *ngIf="dropdown">
  <!-- <rt-icon name="arrow-drop-down"
					 size="medium">
	</rt-icon> -->
  <div class="arrow-dropdown"></div>
</div>

<ng-container *ngIf="hrefTarget && href">
  <a [href]="href" [target]="hrefTarget" [attr.download]="hasDownloadAttribute ? '' : null"> </a>
</ng-container>
<ng-container *ngIf="!hrefTarget && href">
  <a [href]="href" [attr.download]="hasDownloadAttribute ? '' : null"> </a>
</ng-container>
